import React, { useState, useEffect } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { AddGroupSchema } from './MastersSchema';
import { useDispatch, useSelector } from 'react-redux';
import { userListRes, userListTodo } from '../../LMS_Redux/LMS_Slices/Masters/UserList';
import { addUpdateGroupRes, addUpdateGroupTodo } from '../../LMS_Redux/LMS_Slices/Masters/AddUpdateGroup';
import { ToastContainer, toast } from 'react-toastify';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { Spinner } from 'react-bootstrap';

export default function AddGroup() {

    const { state } = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.userList && state.userList.data && state.userList.data.data)
    const [loading, setLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const test = state && state.lms_group_sub_schemas
    // console.log(test)

    const initialValues = {
        id: state ? state.id : '',
        group: state ? state.group_name : '',
        status: state ? state.status : '',
        employee: [],
        old_employee: state ? state.lms_group_sub_schemas : []
    };

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'NAME',
            field: 'vemp_fname',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            width: 300
        },
        {
            headerName: 'ID',
            field: 'vemp_company_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DEPARTMENT',
            field: 'vdepartment_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DESIGNATION',
            field: 'vdesignation_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'EMAIL',
            field: 'vemail',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'PHONE NO.',
            field: 'vmobile_no',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
    ]);

    const user_list_res = () => {
        if (userListRes && userListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const add_update_res = (action) => {
        // console.log(addUpdateGroupRes)
        if (addUpdateGroupRes && addUpdateGroupRes.success) {
            action.resetForm()
            toast.success(addUpdateGroupRes.message, { position: "bottom-right" })
            setSpinner(false)
            setTimeout(() => {
                navigate('/group_list')
            }, 2000);

        } else {
            setSpinner(false)
            toast.error(addUpdateGroupRes.message, { position: "bottom-right" })
        }
    }

    var rowSelectCritera = row => test && test.some(function (ele) {
        return ele.vemp_code == row.vemp_code
    })

    const handleSubmit = (values, action) => {
        // console.log(values);
        // console.log('Selected Data:', values);
        setSpinner(true)
        dispatch(addUpdateGroupTodo(values)).then(() => add_update_res(action))
    };

    useEffect(() => {
        setLoading(true)
        dispatch(userListTodo({ "role": "GRD/2" })).then(() => user_list_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Masters / </span>
                    {state ?
                        <Link to={"/group_list"}><span className='icon2'>Group List / </span></Link>
                        : ''
                    }
                    <span className='icon2'>{state ? "Update" : "Add"} Group</span>
                </div>
                <div className='wrapper-admin'>
                    <Formik initialValues={initialValues} validationSchema={AddGroupSchema} onSubmit={handleSubmit} enableReinitialize>
                        {({ errors, touched, setFieldValue, values, handleChange, handleBlur }) => (
                            <Form>
                                {/* <form onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }} method='post'> */}
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="mb-3">
                                            <label htmlFor="group_name" className="form-label form_label">Add Group</label>
                                            <input type="text" className="form-control form_input" placeholder="Enter Group Name" id='group_name'
                                                name='group' value={values.group} onChange={handleChange} onBlur={handleBlur}
                                            />
                                            {errors.group && touched.group ? (<span className='text-danger form_label'>{errors.group}</span>) : null}
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <label htmlFor="group_status" className="form-label form_label">Status</label>
                                        <select className="form-select form_input" aria-label="Default select example" id='group_status'
                                            name='status' value={values.status} onChange={handleChange} onBlur={handleBlur}
                                        >
                                            <option value="">Select Status</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        {errors.status && touched.status ? (<span className='text-danger form_label'>{errors.status}</span>) : null}
                                    </div>
                                </div>


                                <h6 className='mt-4'>Select Users to Group</h6>

                                {loading ?
                                    <div className='text-center mb-3'>
                                        <PropagateLoader
                                            color="#2262C6"
                                            size={20}
                                        />
                                    </div>
                                    :
                                    <>
                                        <DataTables
                                            rowData={data}
                                            columnDefs={columnDefs}
                                            selection={true}
                                            value={setFieldValue}
                                            field={"employee"}
                                            check={"multiple"}
                                            preSelected={test ? test : ''}
                                            addGroupCheck={true}
                                        />
                                        {errors.employee && touched.employee ? (<span className='text-danger form_label'>{errors.employee}</span>) : null}
                                    </>
                                }

                                <div className='text-end mt-3'>
                                    <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                        {spinner ?
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className='ms-2'
                                            />
                                            : ''
                                        }
                                    </button>
                                </div>
                                {/* </form> */}
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
            <ToastContainer />
        </>
    );
}